import type { PhaseId } from '@finnest/power-admin-contracts';

export const onboardingQueryKeys = {
  root: ['onboarding'] as const,
  overview: (customerId: string) => ['onboarding', 'overview', customerId] as const,
  phase: (customerId: string, phaseId: PhaseId) =>
    ['onboarding', 'phase', customerId, phaseId] as const,
  evidenceRun: (customerId: string, phaseDir: string, runId: string) =>
    ['onboarding', 'evidence', customerId, phaseDir, runId] as const,
  p2ClientConfig: (customerId: string) =>
    ['onboarding', 'p2', 'client-config', customerId] as const,
  p3RunStatus: (customerId: string, runId: string) =>
    ['onboarding', 'p3', 'run-status', customerId, runId] as const,
  p4Snapshot: (customerId: string) => ['onboarding', 'p4', 'snapshot', customerId] as const,
  p4ResolveParticipant: (customerId: string, authorisationServerId: string) =>
    ['onboarding', 'p4', 'resolve-participant', customerId, authorisationServerId] as const,
  p1CounterpartyContacts: (customerId: string) =>
    ['onboarding', 'p1', 'counterparty-contacts', customerId] as const,
  p1DirectoryCertificates: (customerId: string, ecosystem: string) =>
    ['onboarding', 'p1', 'directory-certificates', customerId, ecosystem] as const,
  p5Snapshot: (customerId: string) => ['onboarding', 'p5', 'snapshot', customerId] as const,
  p5RunStatus: (customerId: string, runId: string) =>
    ['onboarding', 'p5', 'run-status', customerId, runId] as const,
  p6Families: (ecosystem: string) => ['onboarding', 'p6', 'families', ecosystem] as const,
  p6Adapters: () => ['onboarding', 'p6', 'adapters'] as const,
  p6Sources: (customerId: string) => ['onboarding', 'p6', 'sources', customerId] as const,
  p6BackfillProgress: (customerId: string, jobId: string) =>
    ['onboarding', 'p6', 'backfill-progress', customerId, jobId] as const,
  p6ReplayDrift: (customerId: string, runId: string) =>
    ['onboarding', 'p6', 'replay-drift', customerId, runId] as const,
  p7Scenarios: (customerId: string) => ['onboarding', 'p7', 'scenarios', customerId] as const,
  p8ReviewState: (customerId: string) => ['onboarding', 'p8', 'review-state', customerId] as const,
  p9DualSignoffState: (customerId: string) =>
    ['onboarding', 'p9', 'dual-signoff-state', customerId] as const,
  p10DefaultDashboards: (customerId: string) =>
    ['onboarding', 'p10', 'default-dashboards', customerId] as const,
  p10DrillStatus: (customerId: string, drillId: string) =>
    ['onboarding', 'p10', 'drill-status', customerId, drillId] as const,
  p11Reconciliation: (customerId: string, batchId: string) =>
    ['onboarding', 'p11', 'reconciliation', customerId, batchId] as const,
  p11CutoverChecklist: (customerId: string, batchId: string) =>
    ['onboarding', 'p11', 'cutover-checklist', customerId, batchId] as const,
};
